import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import resize from '@/mixins/resize';
import * as echarts from 'echarts';
let myChart0 = null;
let myChart1 = null;
let myChart2 = null;
let myChart3 = null;
let myChart4 = null;
import { mapState } from 'vuex';
export default {
  name: 'hollowPie',
  mixins: [resize],
  props: ['panelData', 'itemNum'],
  data() {
    return {
      sourceX: ['保险1', '保险2', '保险3', '保险4', '保险5', '保险6'],
      text: '85%',
      source: [{
        name: '保险1',
        value: 18
      }, {
        name: '保险2',
        value: 35
      }, {
        name: '保险3',
        value: 37
      }, {
        name: '保险4',
        value: 20
      }, {
        name: '保险5',
        value: 36
      }, {
        name: '保险6',
        value: 54
      }]
    };
  },
  computed: {
    ...mapState({
      locale: state => state.setting.locale
    })
  },
  beforeDestroy() {
    if (this.itemNum == 0) {
      myChart0 && myChart0.clear();
    } else if (this.itemNum == 1) {
      myChart1 && myChart1.clear();
    } else if (this.itemNum == 2) {
      myChart2 && myChart2.clear();
    } else if (this.itemNum == 3) {
      myChart3 && myChart3.clear();
    } else if (this.itemNum == 4) {
      myChart4 && myChart4.clear();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemNum == 0) {
        myChart0 = echarts.init(this.$refs.hollowPie);
      } else if (this.itemNum == 1) {
        myChart1 = echarts.init(this.$refs.hollowPie);
      } else if (this.itemNum == 2) {
        myChart2 = echarts.init(this.$refs.hollowPie);
      } else if (this.itemNum == 3) {
        myChart3 = echarts.init(this.$refs.hollowPie);
      } else if (this.itemNum == 4) {
        myChart4 = echarts.init(this.$refs.hollowPie);
      }
      this.initEchart();
    });
  },
  watch: {
    locale: {
      handler() {
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    panelData: {
      handler() {
        if (this.itemNum == 0) {
          myChart0 && myChart0.clear();
          myChart0 = echarts.init(this.$refs.hollowPie);
        } else if (this.itemNum == 1) {
          myChart1 && myChart1.clear();
          myChart1 = echarts.init(this.$refs.hollowPie);
        } else if (this.itemNum == 2) {
          myChart2 && myChart2.clear();
          myChart2 = echarts.init(this.$refs.hollowPie);
        } else if (this.itemNum == 3) {
          myChart3 && myChart3.clear();
          myChart3 = echarts.init(this.$refs.hollowPie);
        } else if (this.itemNum == 4) {
          myChart4 && myChart4.clear();
          myChart4 = echarts.init(this.$refs.hollowPie);
        }
        this.$nextTick(() => {
          this.initEchart();
        });
      }
    },
    deep: true
  },
  methods: {
    initEchart() {
      if (this.panelData) {
        this.sourceX = this.panelData.sourceX;
        // this.source = this.panelData.source;
        this.source = [];
        this.text = this.panelData.totalSourceNum;
        if (this.text == 0) {
          this.source = [{
            name: '',
            value: 0
          }];
        } else {
          this.panelData.source.map(item => {
            if (item.value != '0') {
              this.source.push(item);
            }
          });
        }
      }
      let that = this;
      const option = {
        // color: COLORLIST,
        title: [{
          text: this.$t('总数据') + ':' + that.text,
          textStyle: {
            fontSize: 20
          },
          top: '5',
          left: 'center'
        }],
        tooltip: {
          enterable: true,
          trigger: 'item',
          position: 'bottom',
          formatter: params => {
            return params.marker + ' ' + that.$t(params.name) + '：<br><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span>' + params.value + ' (' + params.percent + '%)';
          }
        },
        legend: {
          show: true,
          left: '15',
          bottom: 10,
          type: 'scroll',
          itemWidth: 18,
          itemHeight: 11,
          data: that.sourceX,
          formatter: function (name) {
            return that.$t(name);
          }
        },
        series: [{
          name: '消费类型',
          type: 'pie',
          icon: 'circle',
          minAngle: 5,
          // radius: [15, 75], // 饼图的大小
          radius: ['40%', '60%'],
          center: ['50%', '45%'],
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1,
            borderRadius: 3
          },
          data: that.source,
          label: {
            normal: {
              show: false
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          }
        }]
      };
      if (this.itemNum == 0) {
        myChart0.setOption(option, true);
      } else if (this.itemNum == 1) {
        myChart1.setOption(option, true);
      } else if (this.itemNum == 2) {
        myChart2.setOption(option, true);
      } else if (this.itemNum == 3) {
        myChart3.setOption(option, true);
      } else if (this.itemNum == 4) {
        myChart4.setOption(option, true);
      }
    }
  }
};